import { render, staticRenderFns } from "./FrequentlyTruckingTable.vue?vue&type=template&id=508c83ca&scoped=true&"
import script from "./FrequentlyTruckingTable.vue?vue&type=script&lang=js&"
export * from "./FrequentlyTruckingTable.vue?vue&type=script&lang=js&"
import style0 from "./FrequentlyTruckingTable.vue?vue&type=style&index=0&id=508c83ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c83ca",
  null
  
)

export default component.exports